// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1JK-K","approved":"Status_approved__3Gd06","rejected":"Status_rejected__zQrzG","expired":"Status_expired__yYuyN","label":"Status_label__1VwI6"};